import {Helmet} from '@dr.pogodin/react-helmet';
import {openDeleteDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {useDeleteTireTransitMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {catchUnhandledDataGridActions, DmsDataGrid, handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function TireTransit() {
  const navigate = useNavigate();

  const [deleteTireTransit] = useDeleteTireTransitMutation();

  const actionCallback: ActionCallback = ({actionKey, rowId, refreshData}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('redirectDetail', 'edit', () =>
        navigate(composePath(settingsRoutes.tireTransitDetail, {params: {id}}))
      )
      .with('delete', () =>
        openDeleteDialog({
          onConfirm: () =>
            deleteTireTransit({transitSettingId: id})
              .unwrap()
              .then(() => refreshData())
              .catch(handleApiError),
        })
      )
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <>
      <Helmet title={i18n.t('entity.tireTransit.labels.title')} />
      <SettingsTemplate
        header={{
          title: i18n.t('entity.tireTransit.labels.title'),
          actions: [
            {
              type: 'button',
              title: i18n.t('entity.tireTransit.labels.newSettings'),
              onClick: () => navigate(settingsRoutes.tireTransitCreate),
            },
          ],
        }}
        data-testid={testIds.settings.tireTransit('template')}
      >
        <DmsDataGrid
          gridCode="tire-transit-setting"
          actionCallback={actionCallback}
          data-testid={testIds.settings.tireTransit('datagrid')}
        />
      </SettingsTemplate>
    </>
  );
}
